import { PayloadAction } from "@reduxjs/toolkit";
import { delay, call, put, takeLatest, all, select } from "redux-saga/effects";
import { AppState } from "../../../store";
import fetchAPI, { ApiResponse, Pagination } from "../../../utils/api";
import bookingSearchSlice, { BookingSearch } from "./slice";

type BookingSearchResponse = ApiResponse<{
  data: BookingSearch[];
  meta: Pagination;
}>;

function* bookingSearchSaga() {
  yield takeLatest(bookingSearchSlice.actions.setSearch, handleSearch);
}

function* handleSearch({ payload: query }: PayloadAction<string>) {
  yield delay(500);

  if (!query) {
    yield put(bookingSearchSlice.actions.reset());

    return;
  }

  const isImported: boolean = yield select(
    (state: AppState) => state.bookingFilters.imported
  );

  const [bookings, archivedBookings]: BookingSearchResponse[][] = yield all([
    call(
      fetchAPI,
      `/search/bookings?query=${query}&is_imported=${Number(isImported)}`
    ),
    call(
      fetchAPI,
      `/search/bookings?query=${query}&is_archived=1&is_imported=${Number(
        isImported
      )}`
    ),
  ]);

  if (bookings && archivedBookings) {
    yield put(
      bookingSearchSlice.actions.setData({ bookings, archivedBookings })
    );
  }

  yield put(bookingSearchSlice.actions.setIsLoading(false));
}

export default bookingSearchSaga;
